import { ChartIds } from "pro-features/components/Chart/src/components/annotations/Helpers/ChartIdsHelper";
import { METADATA_TYPE } from "app/components/widget/widget-types/EngagedVisitsSupportGraphWidget";
import { minVisitsAbbrFilter } from "app/filters/ngFilters";
import { PopTooltipSingle } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/ChartTooltips";
import { CompareModeTooltip } from "app/pages/website-analysis/TrafficAndEngagement/ChartTooltips/CommonChartTooltip";
import { GenericGraph } from "app/pages/website-analysis/TrafficAndEngagement/Components/GenericGraph";
import { PopSingleModeLegends } from "app/pages/website-analysis/TrafficAndEngagement/Legends/PopSingleModeLegends";
import { tooltipPositioner } from "app/pages/website-analysis/TrafficAndEngagement/MD/chartConfig";
import {
    parseData,
    parsePOPSingleModeDataWithMTD,
} from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/ParseServerData";
import {
    dateFormatter,
    getGetExcel,
    getrInitPOPItemsSingleModeWebSources,
    isTimeGranularityDisabled,
    isTimeGranularityDisabledOnlyMonth,
    OVERVIEW_EXCEL_ENDPOINT,
    POP_SINGLE_CHART_TYPE,
} from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/UtilityFunctions";

const ENDPOINT_METRIC = "PageViews";

export const PageViews = (props) => {
    const {
        name,
        getChartTooltipHeaders,
        meta: { isSingleMode, isPOP },
    } = props;
    let metricData;
    const numberFormatter = ({ value }) => minVisitsAbbrFilter()(value, 2);
    if (!isPOP) {
        const addToDashboardName = "EngagementTotalPagesViews";
        const getChartType = () => "line";
        const getExcelLink = getGetExcel(OVERVIEW_EXCEL_ENDPOINT);
        const getGraphData = parseData;
        const chartTooltip = (props) => (
            <CompareModeTooltip
                {...props}
                tableHeaders={getChartTooltipHeaders(props.timeGranularity)}
                xFormatter={dateFormatter}
                yFormatter={numberFormatter}
            />
        );

        metricData = {
            isTimeGranularityDisabled,
            getChartType,
            yAxisLabelsFormatter: numberFormatter,
            getExcelLink,
            addToDashboardName,
            chartType: METADATA_TYPE,
            getGraphData,
            chartTooltip,
            tooltipPositioner,
        };
    } else if (isSingleMode) {
        const addToDashboardName = "EngagementTotalPagesViews";
        const getGraphData = parsePOPSingleModeDataWithMTD;
        const isStacking = () => false;
        const yAxisLabelsFormatter = ({ value }) => value;
        const getExcelLink = getGetExcel(OVERVIEW_EXCEL_ENDPOINT);
        const getChartType = () => "line";
        const chartType = POP_SINGLE_CHART_TYPE;
        const getWebSourceForApi = ({ webSource }) => webSource;
        const getSites = (props) => getrInitPOPItemsSingleModeWebSources(props);
        const legends = (props) => <PopSingleModeLegends {...props} />;
        const chartTooltip = (props) => (
            <PopTooltipSingle
                pointsData={props.points}
                xFormatter={dateFormatter}
                yFormatter={numberFormatter}
            />
        );
        metricData = {
            isTimeGranularityDisabled: isTimeGranularityDisabledOnlyMonth,
            getChartType,
            yAxisLabelsFormatter,
            getExcelLink,
            getGraphData,
            getWebSourceForApi,
            hideLegendsData: true,
            getSites,
            legends,
            chartTooltip,
            isStacking,
            addToDashboardName,
            chartType,
            tooltipPositioner,
        };
    }
    metricData.endpointMetric = ENDPOINT_METRIC;
    metricData.name = name;
    return (
        <GenericGraph
            metric={metricData}
            {...props}
            chartIdForAnnotations={`${ChartIds["TrafficAndEngagementPages"]}`}
        />
    );
};
